import { render } from "./LicensesInfo.vue?vue&type=template&id=72dcd9b8"
import script from "./LicensesInfo.vue?vue&type=script&lang=js"
export * from "./LicensesInfo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__